
import {getProviderList} from '../api/getProviderList';
import {setGetProviderListAction} from '../action';

const setGetProviderList = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getProviderList(params);

            if (data.status === 'success') {
                dispatch(setGetProviderListAction(data.data));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetProviderList
}